<template>
  <div>
  </div>
</template>

<script>
import { useUploadLinkStore } from '@/stores/UploadLinkStore.js';

export default {
  name: "UploadlinkIndex",
  data() {
    return {
      code: "",
    };
  },
  async mounted() {
    this.code = this.$route.params.code;
    // self is no longer needed in async/await where 'this' context is preserved

    if (this.getUploadlinkInfo && this.getUploadlinkInfo.accesstoken) {
      this.$router.push(`/uploadaccess/${this.code}/view`);
      return;
    }

    const uploadLinkStore = useUploadLinkStore();

    try {
      const info = await uploadLinkStore.refreshUploadlinkInfo(this.code);

      if (info && info.brand && info.brand.color) {
        this.$vuetify.theme.themes.dark.colors.primary = info.brand.color;
        this.$vuetify.theme.themes.light.colors.primary = info.brand.color;

        this.$vuetify.theme.themes.dark.colors['on-list'] = info.brand.color;
        this.$vuetify.theme.themes.light.colors['on-list'] = info.brand.color;
      }

      if (info && info.brand && info.brand.backgroundColor) {
        this.$vuetify.theme.themes.dark.colors.background = info.brand.backgroundColor;
        this.$vuetify.theme.themes.light.colors.background = info.brand.backgroundColor;
      }

      if (info && info.brand && info.brand.foregroundColor) {
        this.$vuetify.theme.themes.dark.colors['tw-surface'] = info.brand.foregroundColor;
        this.$vuetify.theme.themes.light.colors['tw-surface'] = info.brand.foregroundColor;

        this.$vuetify.theme.themes.dark.colors['surface'] = info.brand.foregroundColor;
        this.$vuetify.theme.themes.light.colors['surface'] = info.brand.foregroundColor;
      }

      if (info && info.brand && info.brand.foregroundAccentColor) {
        this.$vuetify.theme.themes.dark.colors['tw-surface-accent'] = info.brand.foregroundAccentColor;
        this.$vuetify.theme.themes.light.colors['tw-surface-accent'] = info.brand.foregroundAccentColor;

        this.$vuetify.theme.themes.dark.colors['list'] = info.brand.foregroundAccentColor;
        this.$vuetify.theme.themes.light.colors['list'] = info.brand.foregroundAccentColor;
      }

      if (info.needPassword) {
        this.$router.push(`/uploadaccess/${this.code}/login`);
      } else {
        this.$router.push(`/uploadaccess/${this.code}/view`);
      }
    } catch (error) {
      if (error &&
        error.response &&
        error.response.data &&
        error.response.data.error &&
        error.response.data.error.message
      ) {
        // Handled error
        // console.log("ERROR", error.response.data.error.message);
      } else {
        // unhandled error
        console.log(error);
      }

      this.$router.push(`/uploadaccess/${this.code}/login`);
    }
  },
  computed: {
    getUploadlinkInfo() {
      const uploadLinkStore = useUploadLinkStore();
      return uploadLinkStore.getUploadlinkInfo;
    }
  }
};
</script>

<style>
</style>
